import { useState, useContext, useEffect, useRef, createContext } from "react";
import { Modal, Popover, Row, Col, Table, Button, Input, Checkbox, Form, message, Spin } from "antd";
import { CalendarOutlined, CheckCircleTwoTone, ExclamationCircleTwoTone, RightOutlined, DownOutlined, LoadingOutlined } from "@ant-design/icons";
import Back from "../../../../assets/images/backIcon.svg";
import CustomerSearch from "../../../../assets/images/c-serach.svg";
import clearFilters from "../../../../assets/images/clearFilters.svg";
import printerIcon from "../../../../assets/images/printerIcon.svg";
import Discard from "../../../../assets/images/return.png";
import layAwayIcon from "../../../../assets/images/retrieve.png";
import styles from "../../../../constants/styles.json";
import { useTranslation } from "react-i18next";
import db from "../../../../database";
import messages from "../../../../errors/messages.en-IN.json";
import { v4 as uuidv4 } from "uuid";
import usePOSConfigStore from "../../../../stores/usePOSConfigStore";
import useSessionStore from "../../../../stores/useSessionStore";
import useTransactionStore from "../../../../stores/useTransactionStore";
import sortBy from "lodash/sortBy";
import "../../Retail/styles.css";
const EditableContext = createContext(null);

const EditableRow = ({ index, ...props }) => {
  const [form] = Form.useForm();
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};

const EditableCell = ({ title, editable, children, dataIndex, record, handleSave, setModalEditState, setIsInputFocused, ...restProps }) => {
  const [editing, setEditing] = useState(false);
  const [inputValue, setInputValue] = useState(record?.qtyToReturn);
  const inputRef = useRef(null);
  const form = useContext(EditableContext);
  const { t } = useTranslation();
  useEffect(() => {
    if (editing) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, [editing]);

  const toggleEdit = () => {
    setEditing(!editing);
    setModalEditState(!editing);
    form.setFieldsValue({
      [dataIndex]: record[dataIndex],
    });
  };

  const save = async () => {
    try {
      const values = await form.validateFields();
      values.qtyToReturn = parseFloat(values.qtyToReturn);
      let returnTotal = record.qty - record.returnQty;
      let isDecimalFlag = false;
      await db.products
        .where("mProductId")
        .equalsIgnoreCase(record.product.mProductId)
        .toArray()
        .then((allProducts) => allProducts.filter((p) => p.isactive == true))
        .then((product) => {
          if (product.length > 0 && product[0].uomData[0]?.decimal === "Y" && !Number.isInteger(values.qtyToReturn)) {
            isDecimalFlag = true;
          }
        });

      if (values.qtyToReturn > returnTotal) {
        {
          message.warning(`${t("sales_return_error")}`);
        }
        throw new Error("Qty is more than ordered, invalid value");
      } else if (isDecimalFlag === false && values.qtyToReturn.toString().includes(".")) {
        message.warning(`${messages.warnings.payment.sales_return_qty_error}`);
        throw new Error("Qty is not a valid type, invalid value");
      } else {
        toggleEdit();
        record.qtyToReturn = values.qtyToReturn;
        handleSave({ ...record, ...values });
      }
    } catch (errInfo) {
      console.error("Save failed:", errInfo);
    }
  };

  let childNode = children;
  if (editable) {
    childNode = editing ? (
      <Form.Item
        style={{
          margin: 0,
        }}
        name={dataIndex}
        rules={[
          {
            required: true,
            message: `${title} is required.`,
          },
        ]}
        initialValue={record.qtyToReturn}
      >
        <Input
          className="qtyReturn"
          style={{ width: "40%", height: "5vh", borderRadius: "5px" }}
          onFocus={() => setIsInputFocused(true)}
          ref={inputRef}
          type="text"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onBlur={save}
          onPressEnter={(e) => {
            e.preventDefault();
            save();
          }}
        />
      </Form.Item>
    ) : (
      <div
        className="qtyReturn"
        style={{
          border: "1px solid #d9d9d9",
          padding: "0.4vh 1vw",
          width: "40%",
          borderRadius: "5px",
          fontSize: "14px",
        }}
        onClick={toggleEdit}
      >
        {children}
      </div>
    );
  }
  return <td {...restProps}>{childNode}</td>;
};

const SMPurchaseReturnView = ({
  colorVariable,
  showReturnPurchase,
  setShowReturnPurchase,
  setIsPurchaseReturn,
  setStartRowData,
  setOrderHistoryDetails,
  setExpandedRowKeys,
  expandedRowKeys,
  setDateRange,
  setFiltersFlag,
  filtersFlag,
  setIsInputFocused,
  setSearchhistoryInput,
  setLayoutName,
  searchCustomersRef,
  searchHistoryInput,
  searchOrderHistory,
  dateRange,
  setOpen,
  setInputName,
  keyboard,
  themeJSON,
  tableBodyRef,
  orderHistoryColumns,
  orderHistoryDetails,
  selectedKeys,
  handleExpand,
  content,
  isPopoverVisible,
  setPopoverVisible,
  handleButtonClick,
  getDisplayDate,
  ordersCopy,
  isReturn,
  reconstructedObject,
  handleReceiptReprint,
  posConfig,
  filterdParkedList,
  prevHistoryRef,
  setCheckedKeys,
  checkedKeys,
  searchReturnHistory,
  Discard: DiscardIcon,
  selectedReturnOrder,
  pricePrecision,
  dataSource,
  setDataSource,
  handleSaveReturnCartRecord,
  setModalEditState,
  modalEditState,
  loader,
  // detailsLoading,
  returnProcessRef,
  setShowReturnOptions,
  dateRef,
  tillData,
  setSelectedDocumentType,
  retrieveLayaway,
  setSelectedSaleTypeData,
  updateSaleTypeInStore,
  setSelectedSaleType,
  getFilteredPaymentMethods,
  setStartIndex,
  setShowPayments,
  giftCardItems,
  setSelectedPaymentMethod,
  setKeyValue,
  setSelectedKeys,
  addSelectedReturnProductsToCart,
  loadingDetailOrderId,
}) => {
  const { t } = useTranslation();
  const [selectedRecords, setSelectedRecords] = useState([]);
  const scrollRef = useRef(null);

  useEffect(() => {
    let tableWrapper;
    try {
      const el = scrollRef.current;
      if (!el || typeof el.querySelector !== "function") return;
      tableWrapper = el.querySelector(".ant-table-body");
    } catch {
      return;
    }
    if (!tableWrapper || typeof tableWrapper.addEventListener !== "function") return;
    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = tableWrapper;
      if (scrollHeight - scrollTop - clientHeight < 50 && !filtersFlag && orderHistoryDetails.length > 0) {
        const lengthOff = parseInt(localStorage.getItem("dataLength")) || 0;
        if (lengthOff > 0) {
          searchOrderHistory("customer", searchHistoryInput || "", lengthOff, dateRange?.length > 0, true);
        }
      }
    };
    tableWrapper.addEventListener("scroll", handleScroll);
    return () => tableWrapper.removeEventListener("scroll", handleScroll);
  }, [filtersFlag, orderHistoryDetails.length, searchHistoryInput, dateRange]);

  const onSelectAllChange = (e) => {
    if (e.target.checked) {
      const allKeys = dataSource.map((record) => {
        let giftCardItem = giftCardItems.filter((giftCard) => giftCard.mProductId === record.product.mProductId);
        if (record.returnQty < record.qty && giftCardItem.length === 0) return record.key;
      });
      setCheckedKeys(allKeys);
      setSelectedRecords(dataSource);
    } else {
      setCheckedKeys([]);
      setSelectedRecords([]);
    }
  };

  const onSelect = (record) => {
    const newCheckedKeys = [...checkedKeys];
    const recordKey = record.key;
    let giftCardItem = giftCardItems.filter((giftCard) => giftCard.mProductId === record.product.mProductId);
    if (newCheckedKeys.includes(recordKey)) {
      const index = newCheckedKeys.indexOf(recordKey);
      newCheckedKeys.splice(index, 1);
      const newSelectedRecords = selectedRecords.filter((selectedRecord) => selectedRecord.key !== recordKey);
      setSelectedRecords(newSelectedRecords);
    } else {
      const index = dataSource.findIndex((record) => record.key === recordKey);
      if (dataSource[index].returnQty < dataSource[index].qty && giftCardItem.length === 0) {
        newCheckedKeys.push(recordKey);
      }
      const newSelectedRecords = [...selectedRecords, record];
      setSelectedRecords(newSelectedRecords);
    }
    setCheckedKeys(newCheckedKeys);
  };

  const columns1 = [
    {
      title: <Checkbox onChange={onSelectAllChange} checked={checkedKeys.length === dataSource.length} />,
      width: "7%",
      dataIndex: "selection",
      render: (_, record) => <Checkbox checked={checkedKeys.includes(record.key)} onChange={() => onSelect(record)} />,
    },
    {
      title: "Description",
      dataIndex: "product",
      width: "25%",
      render: (_, record) => {
        return record?.product?.name;
      },
    },
    {
      title: "Unit Price",
      dataIndex: "grossstd",
      width: "15%",
      render: (_, record) => {
        return parseFloat(record.grossstd).toFixed(pricePrecision);
      },
    },
    {
      title: "Qty Ordered",
      dataIndex: "qty",
      width: "15%",
    },
    {
      title: "Remaining Qty",
      dataIndex: "remainingQty",
      width: "15%",
    },
    {
      title: "Qty to Return",
      dataIndex: "qtyToReturn",
      width: "15%",
    },
  ];

  const handleSave = (row) => {
    setIsInputFocused(true);
    const newData = [...dataSource];
    const index = newData.findIndex((item) => row.key === item.key);
    const item = newData[index];
    const updatedItem = { ...item, ...row };
    newData.splice(index, 1, updatedItem);
    setDataSource(newData);
    handleSaveReturnCartRecord(newData);
    setSelectedRecords((prev) => prev.map((rec) => (rec.key === row.key ? { ...rec, ...row } : rec)));
  };

  return (
    <div
      style={{
        background: colorVariable ? colorVariable : "#f3f4f9",
        height: "100vh",
      }}
    >
      {!showReturnPurchase ? (
        <>
          <Row style={{ padding: "1.5em 1.5em 0 1.5em", fontSize: "1vw" }}>
            <Col span={6} style={{ display: "flex", alignItems: "center" }}>
              <img
                src={Back}
                id="sm-salesHistory-back"
                onClick={() => {
                  setIsPurchaseReturn(false);
                  setStartRowData({ startRow: "0", endRow: "10" });
                  setOrderHistoryDetails([]);
                  setExpandedRowKeys([]);
                  setDateRange([]);
                  setFiltersFlag(false);
                  setIsInputFocused(false);
                  setSearchhistoryInput("");
                  setLayoutName("default");
                }}
                style={{
                  height: "2.5vw",
                  cursor: "pointer",
                }}
              />
              <span
                style={{
                  paddingRight: "1vw",
                  color: "#0F0718",
                  fontSize: "1.8em",
                  fontWeight: 500,
                  marginLeft: "0.5em",
                }}
              >
                Sales History
              </span>
            </Col>
            <Col
              span={8}
              offset={2}
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Input
                ref={searchCustomersRef}
                placeholder="Search for Customers/Document Number/Contact"
                prefix={<img src={CustomerSearch} style={{ width: "1.2em", marginRight: "0.3em" }} alt="" />}
                allowClear={false}
                style={{
                  width: "100%",
                  height: "4.5vh",
                  borderRadius: "6px",
                  border: "1px solid #d9d9d9",
                  fontSize: "0.9em",
                  backgroundColor: "#fff",
                }}
                onPressEnter={(e) => {
                  if (e.target.value !== "") {
                    setExpandedRowKeys([]);
                    searchOrderHistory("customer", e.target.value, 0, dateRange?.length > 0 ? true : false);
                  }
                }}
                onBlur={() => {
                  setIsInputFocused(false);
                }}
                value={searchHistoryInput}
                id="sm-salesHistory-customer"
                onFocus={() => {
                  setOpen(true);
                  setIsInputFocused(true);
                  setInputName("salesHistoryInput");
                  keyboard?.current?.setInput(searchHistoryInput);
                }}
                className="salesHistory-input-sm"
                onChange={async (e) => {
                  let inputVal = e.target.value;
                  setSearchhistoryInput(inputVal);
                  keyboard?.current?.setInput(inputVal);
                  if (inputVal === "" && dateRange?.length === 0) {
                    setOrderHistoryDetails([]);
                    setExpandedRowKeys([]);
                  } else if (e.target.value === "" && dateRange?.length !== 0) {
                    await setSearchhistoryInput("");
                    setExpandedRowKeys([]);
                    searchOrderHistory("orderDateSearchKey", dateRange, 0, false);
                  }
                }}
              />
            </Col>

            <Col
              span={8}
              style={{
                paddingLeft: "1vw",
                display: "flex",
                alignItems: "center",
                gap: "0.5vw",
              }}
            >
              <Popover content={content} trigger="click" open={isPopoverVisible} onOpenChange={(visible) => setPopoverVisible(visible)}>
                <Button
                  style={{
                    flex: 1,
                    width: "100%",
                    height: "4.5vh",
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5em",
                    border: "1px solid #d9d9d9",
                    borderRadius: "6px",
                    color: "#929098",
                    fontWeight: 400,
                    fontSize: "1em",
                    backgroundColor: "#fff",
                    paddingLeft: "0.8em",
                  }}
                  onClick={handleButtonClick}
                  ref={dateRef}
                >
                  <CalendarOutlined style={{ color: "#929098", fontSize: "1em" }} />
                  {getDisplayDate()}
                </Button>
              </Popover>

              {filtersFlag ? (
                <Button
                  onClick={() => {
                    setOrderHistoryDetails(ordersCopy);
                    setFiltersFlag(false);
                    setSearchhistoryInput("");
                    setDateRange([]);
                    setTimeout(() => {
                      setInputName("salesHistoryInput");
                      setOpen(false);
                      keyboard?.current?.setInput("");
                    }, 300);
                  }}
                  style={{
                    border: "1px solid #d9d9d9",
                    borderRadius: "6px",
                    height: "4.5vh",
                    display: "flex",
                    alignItems: "center",
                    padding: "0 0.8em",
                    flexShrink: 0,
                  }}
                >
                  <img src={clearFilters} alt="clear" style={{ height: "1.2em" }} />
                </Button>
              ) : null}
            </Col>
          </Row>
          <br />
          <Row style={{ padding: "0 1.5em" }}>
            <Table
              className="sm-cart-table"
              ref={scrollRef}
              style={{
                width: "100%",
                border: "none",
                fontSize: "1.5vw",
                borderRadius: "7px",
                height: "84vh",
                padding: "0 1em",
                background: themeJSON.productTableBGColor || "#fff",
                boxShadow: "0 0 2px rgba(0, 0, 0, 0.2)",
              }}
              scroll={{ y: "78vh" }}
              // loading={{ spinning: detailsLoading, indicator: <LoadingOutlined style={{ fontSize: 28 }} spin /> }}
              onRow={(record) => ({
                onClick: () => {
                  if (!loadingDetailOrderId) handleExpand(record);
                },
              })}
              pagination={false}
              columns={orderHistoryColumns()}
              dataSource={orderHistoryDetails}
              rowClassName={(record) => (selectedKeys[0] === record.key ? "tableSelectedBlue" : "tableNonSelectedWhite")}
              expandable={{
                columnWidth: 30,
                expandedRowKeys,
                onExpand: (_, record) => handleExpand(record),
                expandedRowRender: (record) => {
                  const isLoadingDetails = loadingDetailOrderId === record.sOrderID;
                  const hideAmounts = posConfig?.hideSalesAmountInSalesHistory === "Y";
                  return (
                    <div
                      style={{
                        padding: "1% 4% 1% 4%",
                        backgroundColor: "#f3f4f9",
                      }}
                    >
                      {isLoadingDetails ? (
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "40px 0" }}>
                          <Spin indicator={<LoadingOutlined style={{ fontSize: 28 }} spin />} tip="Loading sale details..." />
                        </div>
                      ) : (
                        <Row>
                          {!hideAmounts && <Col span={21}>
                            <Row
                              style={{
                                marginBottom: "6px",
                                alignItems: "center",
                              }}
                            >
                              <Col
                                span={12}
                                style={{
                                  fontSize: "1rem",
                                  fontWeight: 500,
                                  color: "#0F0718",
                                  textAlign: "left",
                                  paddingLeft: "2px",
                                }}
                              >
                                Description
                              </Col>

                              <Col
                                span={3}
                                style={{
                                  fontSize: "1rem",
                                  fontWeight: 500,
                                  color: "#0F0718",
                                  textAlign: "center",
                                }}
                              >
                                Qty
                              </Col>

                              <Col
                                span={4}
                                style={{
                                  fontSize: "1rem",
                                  fontWeight: 500,
                                  color: "#0F0718",
                                  textAlign: "right",
                                  paddingRight: "10px",
                                }}
                              >
                                Unit Price
                              </Col>

                              <Col
                                span={5}
                                style={{
                                  fontSize: "1rem",
                                  fontWeight: 500,
                                  color: "#0F0718",
                                  textAlign: "right",
                                  paddingRight: "28px",
                                }}
                              >
                                Net Total
                              </Col>
                            </Row>

                            <Row
                              style={{
                                paddingBottom: "10px",
                                alignItems: "flex-start",
                              }}
                            >
                              {(record.items || []).map((e) => {
                                return (
                                  <>
                                    <Col
                                      span={12}
                                      style={{
                                        fontSize: "0.95rem",
                                        fontWeight: 400,
                                        color: "#0F0718",
                                        lineHeight: "1.6",
                                        wordBreak: "break-word",
                                        paddingLeft: "2px",
                                      }}
                                    >
                                      {e.name}
                                    </Col>
                                    <Col
                                      span={3}
                                      style={{
                                        textAlign: "center",
                                        fontSize: "0.95rem",
                                        fontWeight: 400,
                                        color: "#0F0718",
                                      }}
                                    >
                                      {e.weight}
                                    </Col>
                                    <Col
                                      span={4}
                                      style={{
                                        textAlign: "right",
                                        fontSize: "0.95rem",
                                        fontWeight: 400,
                                        color: "#0F0718",
                                        paddingRight: "10px",
                                      }}
                                    >
                                      {e && typeof e.salePrice === "number" && e.salePrice.toFixed(pricePrecision)}
                                    </Col>
                                    <Col
                                      span={5}
                                      style={{
                                        textAlign: "right",
                                        fontSize: "0.95rem",
                                        fontWeight: 400,
                                        color: "#0F0718",
                                        paddingRight: "28px",
                                      }}
                                    >
                                      {(e.nettotal || 0).toFixed(pricePrecision)}
                                    </Col>
                                  </>
                                );
                              })}
                            </Row>
                            <div
                              style={{
                                width: "96%",
                                borderTop: "1px solid rgba(52, 40, 44, 0.25)",
                                marginTop: "4px",
                                marginBottom: "10px",
                              }}
                            />
                            <Row style={{ paddingTop: "5px" }}>
                              <Col span={14}>
                                {record?.paymentData?.length > 0 && (
                                  <Row>
                                    <Col span={8} style={{ textAlign: "left" }}>
                                      <p style={{ margin: "0", fontWeight: "500", textAlign: "left" }}>Payment method</p>
                                    </Col>
                                    <Col span={5}>
                                      <p style={{ margin: "0", fontWeight: "500", textAlign: "left" }}>Amount</p>
                                    </Col>
                                    <Col span={8}>
                                      <p style={{ margin: "0", fontWeight: "500", textAlign: "left" }}>Advance Payment</p>
                                    </Col>
                                  </Row>
                                )}

                                {record?.paymentData?.map((ele, ind) => (
                                  <Row key={ind}>
                                    <Col span={8} style={{ textAlign: "left" }}>
                                      {ele.name}
                                    </Col>
                                    <Col span={5}>{ele.amount}</Col>
                                    {ind === 0 && <Col span={8}>{record.advancePayment > 0 && record.layAway === "Y" ? record.advancePayment : 0}</Col>}
                                  </Row>
                                ))}
                              </Col>
                              <Col span={3} offset={3} className="td-subtotal">
                                <span className="td-subTotalText">Subtotal</span>
                                <span className="td-subTotalText">Total tax</span>
                              </Col>
                              <Col span={3} className="td-subtotal" style={{ textAlign: "right" }}>
                                <span className="td-subTotalText">{((record.total || 0) - (record.tax || 0)).toFixed(pricePrecision)}</span>
                                <span className="td-subTotalText">{(record.tax || 0).toFixed(pricePrecision)}</span>
                              </Col>
                            </Row>
                            <Row style={{ marginBottom: "1%" }}>
                              <Col span={3} offset={17} className="td-subtotal" style={{ padding: "4px 0" }}>
                                <span className="td-total">SALE TOTAL</span>
                              </Col>
                              <Col
                                span={3}
                                style={{
                                  fontSize: "1.1em",
                                  borderBottom: "1px solid rgba(52, 40, 44, 0.55)",
                                  textAlign: "right",
                                  paddingTop: "4px",
                                }}
                              >
                                <span className="td-total">{parseFloat(record.total).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision)}</span>
                              </Col>
                            </Row>
                          </Col>}
                          <Col
                            span={hideAmounts ? 24 : 3}
                            className="td-bottons"
                            style={{
                              fontSize: "1vw",
                              display: "flex",
                              flexDirection: hideAmounts ? "row" : "column",
                              gap: "12px",
                              justifyContent: hideAmounts ? "flex-end" : "center",
                              alignItems: "center",
                            }}
                          >
                            {isReturn ? (
                              reconstructedObject?.ReturnPrint === "N" ? null : (
                                <p
                                  id="sm-salesHistory-printer"
                                  style={{
                                    cursor: "pointer",
                                    padding: "5.5% 12%",
                                    borderRadius: "5px",
                                    border: "1px solid #fff",
                                    backgroundColor: "#fff",
                                    fontSize: "1em",
                                    fontWeight: 500,
                                    color: "#0F0718",
                                  }}
                                  onClick={() => handleReceiptReprint(record)}
                                >
                                  <img
                                    src={printerIcon}
                                    style={{
                                      height: "1.4vw",
                                      paddingRight: "0.4vw",
                                      cursor: "pointer",
                                    }}
                                  />
                                  Print receipt
                                </p>
                              )
                            ) : reconstructedObject?.Reprint === "N" || !(record.items || []).some((item) => Math.abs(parseFloat(item.weight)) > 0) ? null : (
                              <p
                                id="sm-salesHistory-printer"
                                style={{
                                  cursor: "pointer",
                                  width: hideAmounts ? "auto" : "100%",
                                  padding: "5px 6px",
                                  borderRadius: "6px",
                                  border: "1px solid #F2F2F2",
                                  backgroundColor: "#FFFFFF",
                                  fontSize: "1.2em",
                                  fontWeight: 400,
                                  color: "#0F0718",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "6px",
                                  boxSizing: "border-box",
                                }}
                                onClick={() => handleReceiptReprint(record, { orderCompleted: true })}
                              >
                                <img
                                  src={printerIcon}
                                  style={{
                                    width: "18px",
                                    height: "18px",
                                    objectFit: "contain",
                                    flexShrink: 0,
                                  }}
                                />
                                Print receipt
                              </p>
                            )}
                            {record.creditSale === "Y" ? (
                              <p
                                style={{
                                  cursor: "pointer",
                                  padding: "5.5% 13%",
                                  borderRadius: "5px",
                                  border: "1px solid #fff",
                                  backgroundColor: "#fff",
                                  fontSize: "1em",
                                  fontWeight: 500,
                                  color: "#0F0718",
                                }}
                                id="sm-sales-return"
                                onClick={async () => {
                                  const storedParkedList = JSON.parse(localStorage.getItem("parkedList"));
                                  const isDocnoInList = storedParkedList?.some((item) => item.parkedDocNo === record.documentno);
                                  if (isDocnoInList) {
                                    Modal.info({
                                      title: "This order is already parked. Please access it from the bill parking area to continue.",
                                      icon: null,
                                      cancelText: "No",
                                      okText: "Okay",
                                      autoFocusButton: null,
                                      okButtonProps: { style: { display: "inline-block" } },
                                    });
                                  } else {
                                    setIsPurchaseReturn(false);
                                    record.isCreditSale = "Y";
                                    retrieveLayaway(record);
                                    // setSelectedDocumentType("Advance");
                                    setOrderHistoryDetails([]);
                                    const saleData = await db.posSaletypes.toArray();
                                    saleData.forEach((item) => {
                                      if (item.cwrSaletype.cwrSaletypeId === record.saleType.cwrSaletypeId) {
                                        setSelectedSaleTypeData(item);
                                        localStorage.setItem("saleTypeData", JSON.stringify(item));
                                        setSelectedSaleType(item?.cwrSaletype?.name);
                                      }
                                    });
                                    let paymentDetails = getFilteredPaymentMethods(record?.saleType?.cwrSaletypeId || null);
                                    let payments = paymentDetails.length >= 5 ? sortBy(paymentDetails, "sequenceNo").slice(0, 4) : paymentDetails;
                                    setStartIndex(payments.length);
                                    setShowPayments(payments);
                                  }
                                }}
                              >
                                <img
                                  src={layAwayIcon}
                                  style={{
                                    height: "1vw",
                                    paddingRight: "0.4vw",
                                  }}
                                />
                                Retrieve Credit Sale
                              </p>
                            ) : parseFloat(record.total) > 0 && posConfig?.showSalesReturn === "Y" && record.layAway === "N" && record.paid !== 0 ? (
                              <p
                                style={{
                                  cursor: "pointer",
                                  width: hideAmounts ? "auto" : "100%",
                                  padding: "5px 6px",
                                  borderRadius: "6px",
                                  border: "1px solid #F2F2F2",
                                  backgroundColor: "#FFFFFF",
                                  fontSize: "1.2em",
                                  fontWeight: 400,
                                  color: "#0F0718",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "6px",
                                  boxSizing: "border-box",
                                }}
                                id="sm-sales-return"
                                onClick={() => {
                                  const isAlreadyParked = filterdParkedList.some((item) => item.parkedOrderID === record.sOrderID);
                                  if (isAlreadyParked) {
                                    Modal.error({
                                      title: "This return order is already parked. Please access it from the bill parking area to continue.",
                                    });
                                  } else {
                                    prevHistoryRef.current = orderHistoryDetails;
                                    setCheckedKeys([]);
                                    searchReturnHistory(record.documentno, record);
                                    setOrderHistoryDetails([]);
                                    useTransactionStore.getState().setSalesReturn("Y");
                                  }
                                }}
                              >
                                <img
                                  src={Discard}
                                  style={{
                                    width: "16px",
                                    height: "16px",
                                    objectFit: "contain",
                                    flexShrink: 0,
                                  }}
                                />
                                Sales Return
                              </p>
                            ) : record.type === "Layaway" && posConfig?.enablePreOrder !== "Y" ? (
                              <p
                                style={{
                                  cursor: "pointer",
                                  padding: "5.5% 13%",
                                  borderRadius: "5px",
                                  border: "1px solid #fff",
                                  backgroundColor: "#fff",
                                  fontSize: "1em",
                                  fontWeight: 500,
                                  color: "#0F0718",
                                }}
                                id="sm-sales-return"
                                onClick={async () => {
                                  const storedParkedList = useSessionStore.getState().parkedList;
                                  const isDocnoInList = storedParkedList?.some((item) => item.parkedDocNo === record.documentno);
                                  if (isDocnoInList) {
                                    Modal.info({
                                      title: "This layaway order is already parked. Please access it from the bill parking area to continue.",
                                      icon: null,
                                      cancelText: "No",
                                      okText: "Okay",
                                      autoFocusButton: null,
                                      okButtonProps: { style: { display: "inline-block" } },
                                    });
                                  } else {
                                    setIsPurchaseReturn(false);
                                    const advanceItem = record.items.find(
                                      (item) =>
                                        item.type === "S" &&
                                        item.weight > 0 &&
                                        posConfig?.AllowServiceItemsinAdvanceOrderCompletion === "N" &&
                                        !posConfig?.AllowServiceItemsinAdvanceOrderCompletion
                                    );
                                    record.docType = "Advance";
                                    retrieveLayaway(record);
                                    setSelectedDocumentType("Advance");
                                    setOrderHistoryDetails([]);
                                    const saleData = await db.posSaletypes.toArray();
                                    saleData.map((item) => {
                                      if (item.cwrSaletype.cwrSaletypeId === record.saleType.cwrSaletypeId) {
                                        setSelectedSaleTypeData(item);
                                        updateSaleTypeInStore(item);
                                        setSelectedSaleType(item?.cwrSaletype?.name);
                                      }
                                    });
                                    let paymentDetails = getFilteredPaymentMethods(record?.saleType?.cwrSaletypeId || null);
                                    if (
                                      !advanceItem &&
                                      posConfig?.allowLayawaywithoutPayment !== "Y" &&
                                      !record.items.some((item) => item.type === "S" && item?.productSegment === "AD" && item.weight > 0)
                                    ) {
                                      paymentDetails = [
                                        ...paymentDetails,
                                        ...(posConfig?.enablePreOrder !== "Y"
                                          ? [
                                              {
                                                cWRPaymentMethodID: "",
                                                sequenceNo: 9999,
                                                finPaymentmethodId: "",
                                                finFinancialAccountId: "",
                                                finDayCloseAccountId: null,
                                                name: "Complete Order",
                                                integratedPayment: false,
                                                isloyalty: false,
                                                paymentProvider: null,
                                                iscredit: false,
                                                isGiftCard: false,
                                                isDefault: "N",
                                                csCurrencyId: "",
                                                isoCode: "AED",
                                                isactive: true,
                                                salesType: [],
                                              },
                                            ]
                                          : []),
                                      ];
                                    }
                                    let payments =
                                      paymentDetails.length > 5
                                        ? sortBy(paymentDetails, "sequenceNo").slice(
                                            0,
                                            tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId === record?.customer?.cwrCustomerId && paymentDetails.length === 5 ? 4 : 4
                                          )
                                        : paymentDetails;
                                    setStartIndex(payments.length);
                                    setShowPayments(payments);
                                  }
                                }}
                              >
                                <img
                                  src={layAwayIcon}
                                  style={{
                                    height: "1vw",
                                    paddingRight: "0.4vw",
                                  }}
                                />
                                Retrieve Sale
                              </p>
                            ) : null}
                          </Col>
                        </Row>
                      )}
                    </div>
                  );
                },
                rowExpandable: (record) => record.name !== "Not Expandable",
                expandIcon: ({ expanded, onExpand, record }) => (
                  <span id="sm-salesHistory-expand" onClick={(e) => onExpand(record, e)}>
                    {expanded ? <DownOutlined style={{ color: "#929098" }} /> : <RightOutlined style={{ color: "#929098" }} />}
                  </span>
                ),
              }}
            />
          </Row>
        </>
      ) : (
        <>
          <Row
            style={{
              padding: "1.5em 1.5em 1em 1.5em",
              fontSize: "1vw",
            }}
          >
            <Col span={6}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img
                  src={Back}
                  id="sm-salesReturn"
                  onClick={() => {
                    setOrderHistoryDetails(ordersCopy);
                    setShowReturnPurchase(!showReturnPurchase);
                    setSearchhistoryInput("");
                    setDateRange([]);
                    setFiltersFlag(false);
                  }}
                  style={{
                    height: "2.5vw",
                    cursor: "pointer",
                  }}
                />

                <span
                  style={{
                    marginLeft: "0.5em",
                    fontSize: "1.7em",
                    fontWeight: 500,
                    color: "#0F0718",
                    lineHeight: 1,
                  }}
                >
                  Return Purchase
                </span>
              </div>
            </Col>
          </Row>
          <br />
          <Row style={{ padding: "0 1.5em 1.5em 1.5em", fontSize: "1vw" }}>
            <Col span={6} style={styles.screenStyles.returnPurchase.docNo}>
              Document No: {selectedReturnOrder.documentno}
            </Col>
            <Col span={6} style={styles.screenStyles.returnPurchase.docNo}>
              Date : {selectedReturnOrder.dateordered}
            </Col>
            <Col span={6} style={styles.screenStyles.returnPurchase.docNo}>
              Total : {selectedReturnOrder.grosstotal}
            </Col>
            <Col span={6} style={styles.screenStyles.returnPurchase.docNo}>
              Discount : {parseFloat(selectedReturnOrder.discAmount).toFixed(pricePrecision)}
            </Col>
          </Row>
          <Row style={{ padding: "0 1.5em", fontSize: "1vw" }}>
            <Table
              className="sm-cart-table-return"
              style={{
                width: "100%",
                overflowY: "auto",
                border: "none",
                fontSize: "1.1vw",
                borderRadius: "7px",
                height: "43vh",
                padding: "0 1em",
                background: themeJSON.productTableBGColor || "#fff",
                boxShadow: "0 0 2px rgba(0, 0, 0, 0.2)",
              }}
              pagination={false}
              dataSource={dataSource}
              components={{
                body: {
                  row: EditableRow,
                  cell: EditableCell,
                },
              }}
              columns={columns1.map((col) => ({
                ...col,
                onCell: (record) => ({
                  record,
                  editable: col.dataIndex === "qtyToReturn" && record?.product?.returnable,
                  dataIndex: col.dataIndex,
                  title: col.title,
                  handleSave: handleSave,
                  setModalEditState: setModalEditState,
                  setIsInputFocused: setIsInputFocused,
                }),
              }))}
            />
          </Row>
          <Row style={{ paddingTop: "2vh" }}>
            <Col span={9}></Col>
            <Col span={4} />
            <Col span={11}>
              <Row style={{ fontSize: "1vw" }}>
                <Col span={11} offset={1}>
                  <p style={styles.screenStyles.returnPurchase.returnItems}>Return Items / Qty: </p>
                  <p style={styles.screenStyles.returnPurchase.returnAmount}>Return Amount Total:</p>
                </Col>
                <Col span={11} style={{ textAlign: "right" }}>
                  <p style={styles.screenStyles.returnPurchase.returnItems}>
                    {" "}
                    {selectedReturnOrder.itemsToReturn ? selectedReturnOrder.itemsToReturn : "0"} /{" "}
                    {selectedReturnOrder.itemsQtyToReturn ? parseFloat(selectedReturnOrder.itemsQtyToReturn).toFixed(2) : "0.00"}
                  </p>
                  <p style={styles.screenStyles.returnPurchase.returnAmount}>
                    {" "}
                    {selectedReturnOrder.returnAmountTotal ? parseFloat(selectedReturnOrder.returnAmountTotal).toFixed(pricePrecision) : "0.00"}
                  </p>
                </Col>
              </Row>
              <Row style={{ marginTop: "10vh", fontSize: "1vw" }}>
                <Col span={8} />
                <Col span={8}>
                  <Button
                    style={{
                      width: "85%",
                      height: "5.5vh",
                      fontSize: "1.2em",
                      fontWeight: "500",
                      borderColor: "#fff",
                      color: "#0F0718",
                      borderRadius: "7px",
                      border: "1px solid rgba(146, 144, 152, 0.5)",
                      marginLeft: "2.5vw",
                    }}
                    onClick={() => {
                      setShowReturnPurchase(!showReturnPurchase);
                      setOrderHistoryDetails(prevHistoryRef.current);
                    }}
                    disabled={loader}
                  >
                    Cancel
                  </Button>
                </Col>
                <Col span={1} />
                <Col span={8}>
                  <Button
                    style={{
                      width: "85%",
                      height: "5.5vh",
                      fontSize: "1.2em",
                      fontWeight: "500",
                      backgroundColor: "#2F3856",
                      color: "#fff",
                      borderRadius: "7px",
                      marginLeft: "1vw",
                    }}
                    ref={returnProcessRef}
                    onClick={async (e) => {
                      const filteredKeys = checkedKeys.filter((key) => key !== null && key !== undefined);
                      if (filteredKeys.length === 0) {
                        message.warning("Please select at least one item to return.");
                        return;
                      }
                      if (posConfig?.allowReturnRefund === "Y" || posConfig?.allowReturnCreditNote === "Y" || posConfig?.allowReturnExchange === "Y") {
                        setShowReturnOptions(true);
                      } else {
                        useTransactionStore.getState().setSelectedReturnType("REFUND");
                        const result = await addSelectedReturnProductsToCart(filteredKeys);
                        if (result) {
                          setIsPurchaseReturn(false);
                          setStartRowData({ startRow: "0", endRow: "10" });
                          setIsInputFocused(true);
                        }
                      }
                    }}
                    className="focusDashboardCard"
                  >
                    Return
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </>
      )}
    </div>
  );
};

export default SMPurchaseReturnView;
